import { ModalBody, Button } from 'reactstrap';
import { Formik } from 'formik';
import {
  DeleteButton,
  SubmitButton,
  TemplateForm,
} from './template-components';
import Modal from '../basics/Modal';
import { getFirstMutationResult } from '../../utils/graphql';

const ModalForm = ({
  editing,
  onSubmit,
  onDelete,
  onClose,
  loading,
  validationSchema,
  children,
  ...props
}) => {
  const closeOnSuccess = (response) => {
    if (getFirstMutationResult(response?.data)) onClose();
  };

  const submitAndClose = (...params) => {
    onSubmit(...params).then(closeOnSuccess);
  };

  const deleteAndClose = (...params) => {
    onDelete(...params).then(closeOnSuccess);
  };

  return (
    <Modal isOpen={!!editing} onClose={onClose} {...props}>
      <ModalBody>
        <Formik
          initialValues={editing}
          onSubmit={submitAndClose}
          validationSchema={validationSchema}
        >
          {(formik) => {
            const { isSubmitting } = formik;
            return (
              <TemplateForm $removePadding>
                {typeof children === 'function' ? children(formik) : children}
                <div className="d-flex justify-content-between mt-2">
                  <div>
                    {editing?.id && (
                      <DeleteButton
                        onDelete={() => deleteAndClose(editing)}
                        disabled={isSubmitting || loading}
                        size="sm"
                      />
                    )}
                  </div>
                  <div>
                    <Button
                      onClick={onClose}
                      className="ml-1"
                      size="sm"
                      disabled={isSubmitting || loading}
                    >
                      Cancel
                    </Button>
                    <SubmitButton
                      loading={loading}
                      size="sm"
                      className="ml-2"
                    />
                  </div>
                </div>
              </TemplateForm>
            );
          }}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default ModalForm;
